import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFormatSmallCaps = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 21,
	fill: "none",
	viewBox: "0 0 20 21",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M2.75 16.25 6.5 5.75l3.75 10.5M4 12.75h5m5.752-.5c.998 0 1.748-.5 1.748-1.75 0-1-.75-1.75-1.748-1.75H13c-.25 0-.25 0-.25.25v3.25m2.002 0h.712c1.286 0 1.786 1 1.786 2s-.5 2-1.786 2H13c-.25 0-.25 0-.25-.25v-3.75m2.002 0H12.75"
	})]
});
const ForwardRef = forwardRef(SvgFormatSmallCaps);
export { ForwardRef as ReactComponent };
